import type { IconComponent } from '../types'

/** `(❓)` Icon */
export const Help: IconComponent = ({ width, height, ...restOfProps }) => (
    <svg
        width={width}
        height={height}
        viewBox='0 0 25 25'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        className='help-icon'
        {...restOfProps}
    >
        <title>help icon</title>
        <path
            d='M7.5 8.441c0-.606.143-1.213.571-1.819.429-.606.858-1.213 1.572-1.516.714-.454 1.571-.606 2.428-.606.858 0 1.715.152 2.286.455a4.53 4.53 0 011.572 1.364c.428.606.571 1.213.571 1.97a3.18 3.18 0 01-.286 1.365c-.143.454-.428.758-.714 1.06-.286.304-.857.759-1.571 1.516-.143.152-.429.304-.429.455-.143.152-.286.303-.286.455 0 .152-.143.303-.143.303 0 .152-.142.303-.142.607-.143.606-.429 1.06-1.143 1.06-.286 0-.572-.151-.857-.303-.286-.151-.286-.606-.286-.91 0-.605.143-1.06.286-1.363.142-.455.428-.758.571-1.061l1-1.061c.429-.304.714-.607.857-.758.143-.152.286-.455.429-.607.143-.151.143-.454.143-.758 0-.454-.143-.909-.572-1.364a2.316 2.316 0 00-1.428-.454c-.715 0-1.143.151-1.429.606-.286.303-.571.91-.857 1.516-.143.758-.572 1.06-1.143 1.06-.286 0-.571-.15-.857-.454 0-.303-.143-.455-.143-.758zM11.929 18.9c-.429 0-.715-.152-1-.455-.286-.303-.429-.606-.429-1.06 0-.456.143-.759.429-1.062.285-.303.571-.455 1-.455.428 0 .714.152 1 .455.285.303.428.607.428 1.061 0 .455-.143.758-.428 1.061-.286.303-.572.455-1 .455z'
            fill='currentColor'
        />
        <path
            d='M23.505 12.128c0 6.283-5.094 11.377-11.377 11.377C5.844 23.505.75 18.411.75 12.128.75 5.844 5.844.75 12.128.75c6.283 0 11.377 5.094 11.377 11.378z'
            stroke='currentColor'
            strokeWidth='1.5'
        />
    </svg>
)
